<template>
  <div>
    <v-overlay :value="overlay_load" z-index="1000">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Favourite Confirmation Dialog -->
    <v-dialog v-model="favouriteConfirmDialog" max-width="450" persistent>
      <v-card class="rounded-lg">
        <v-card-title class="d-flex align-center py-4" :style="{
          background: pendingFavouriteHost === 'STARR'
            ? 'linear-gradient(90deg, rgba(233, 30, 99, 0.1) 0%, rgba(156, 39, 176, 0.1) 50%, rgba(63, 81, 181, 0.1) 100%)'
            : pendingFavouriteHost === 'BOARD'
              ? 'linear-gradient(90deg, rgba(255, 152, 0, 0.1) 0%, rgba(255, 87, 34, 0.1) 50%, rgba(244, 67, 54, 0.1) 100%)'
              : 'linear-gradient(90deg, rgba(57, 130, 219, 0.1) 0%, rgba(87, 130, 199, 0.1) 50%, rgba(137, 83, 237, 0.1) 100%)'
        }">
          <v-icon
            :color="pendingFavouriteHost === 'STARR' ? '#9C27B0' : pendingFavouriteHost === 'BOARD' ? '#FF5722' : '#5782C7'"
            size="28" class="mr-3">mdi-heart</v-icon>
          <span :style="{
            color: pendingFavouriteHost === 'STARR' ? '#9C27B0' : pendingFavouriteHost === 'BOARD' ? '#FF5722' : '#5782C7',
            fontWeight: '600',
            fontSize: '18px'
          }">Set as Favourite</span>
        </v-card-title>
        <v-card-text class="pt-4 pb-2">
          <div class="text-body-1" style="color: #3F4254; line-height: 1.6;">
            <p class="mb-3">
              Are you sure you want to set <strong :style="{
                color: pendingFavouriteHost === 'STARR' ? '#9C27B0' : pendingFavouriteHost === 'BOARD' ? '#FF5722' : '#5782C7'
              }">{{ pendingFavouriteHost }}</strong> as your favourite?
            </p>
            <v-alert dense text type="info" class="mb-0" style="font-size: 13px;">
              <strong>What this means:</strong> After you login, you will be automatically redirected to
              <strong :style="{
                color: pendingFavouriteHost === 'STARR' ? '#9C27B0' : pendingFavouriteHost === 'BOARD' ? '#FF5722' : '#5782C7'
              }">{{ pendingFavouriteHost }}</strong> page directly.
            </v-alert>
          </div>
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="cancelFavouriteDialog">
            Cancel
          </v-btn>
          <v-btn :style="{
            background: pendingFavouriteHost === 'STARR'
              ? 'linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)'
              : pendingFavouriteHost === 'BOARD'
                ? 'linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%)'
                : 'linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%)',
            color: 'white'
          }" @click="confirmSetFavourite">
            <v-icon left small>mdi-heart</v-icon>
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="switch_tabs_dialog" persistent max-width="900px">
      <v-card class="switch-company-card">
        <div class="pt-3 ml-3 custom-header d-flex justify-space-between align-center"
          style="border-bottom: 1px solid #e0e0e0;">
          <!-- padding: 16px 24px; -->
          <div style="font-size: 20px; font-weight: 500; color: #2c3e50;">
            {{ isSingleEntityScenario ? 'Switch Host' : 'Switch Options' }}
          </div>
          <div class="d-flex align-center">
            <v-tooltip bottom v-if="entity_id && !isSingleEntityScenario">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon small @click="clearEntitySelection" color="#3F51B5" v-bind="attrs" v-on="on" class="mr-2">
                  <v-icon color="#3F51B5">mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Change Entity</span>
            </v-tooltip>
          </div>
        </div>
        <v-card-text>
          <!-- Single Entity Scenario - Direct Host Selection -->
          <v-row v-if="isSingleEntityScenario" class="pt-3">
            <v-col cols="12">
              <!-- Entity Info Display -->
              <v-alert type="info" text dense class="mb-4">
                <strong>Entity:</strong> {{ singleEntityName }}
              </v-alert>

              <!-- Company Selection for Single Entity (if company data available) -->
              <div v-if="has_company_data && company_dataset && company_dataset.length > 0" class="mb-4">
                <div class="section-title mb-3">Select Company</div>
                <div class="selection-list company-list">
                  <div v-for="(company, company_index) in company_dataset" :key="'company-' + company.id"
                    class="selection-item mb-2" :style="{
                      borderRadius: '8px',
                      cursor: 'pointer',
                      background: company_id === company.id ? hexToRgba('#4CAF50', 0.12) : '#F3F6F9',
                      padding: '12px 16px',
                      borderLeft: company_id === company.id ? '4px solid #4CAF50' : '4px solid transparent',
                      transition: 'all 0.2s ease'
                    }" @click="selectCompany(company)">
                    <div class="d-flex align-center">
                      <img :src="company_id === company.id
                        ? is_boardpage ? require('@/assets/switch_company_icon/selected_company_radio_button_boardpage.svg')
                          : require('@/assets/switch_company_icon/selected_company_radio_button.svg')
                        : require('@/assets/switch_company_icon/ompany_radio_button.svg')" alt="Company Radio"
                        class="mr-2" style="width: 14px; height: 14px; cursor: pointer;" />
                      <span class="selection-label company-label">{{ company.name }}</span>
                      <v-icon v-if="company_id === company.id" color="#4CAF50" size="18"
                        class="ml-auto">mdi-check-circle</v-icon>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Host Options with Star Icons -->
              <div class="section-title mb-3">Select Host to Switch</div>

              <!-- Starr Host -->
              <div v-if="singleEntityData && singleEntityData.starr_flag" class="selection-item mb-3 starr-host-item"
                :style="{
                  borderRadius: '8px',
                  cursor: 'pointer',
                  background: selected_host === 'starr' ? 'linear-gradient(90deg, rgba(233, 30, 99, 0.06) 0%, rgba(156, 39, 176, 0.06) 50%, rgba(63, 81, 181, 0.06) 100%)' : '#F3F6F9',
                  padding: '16px',
                  borderLeft: 'none',
                  boxShadow: selected_host === 'starr' ? '0 2px 8px rgba(156, 39, 176, 0.12)' : 'none',
                  position: 'relative',
                  overflow: 'hidden'
                }" @click="selectHostForSingleEntity('starr')">
                <div class="starr-gradient-bar" :style="{
                  position: 'absolute',
                  left: '0',
                  top: '0',
                  bottom: '0',
                  width: '4px',
                  background: 'linear-gradient(180deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)'
                }"></div>
                <div class="d-flex align-center justify-space-between">
                  <div class="d-flex align-center">
                    <v-icon :style="selected_host === 'starr' ? {
                      background: 'linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    } : {}" :color="selected_host === 'starr' ? '' : '#7E8299'" size="24" class="mr-3">
                      {{ selected_host === 'starr' ? 'mdi-star' : 'mdi-star-outline' }}
                    </v-icon>
                    <div>
                      <div class="selection-label host-label" :style="selected_host === 'starr' ? {
                        background: 'linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        fontSize: '16px',
                        fontWeight: '600'
                      } : { fontSize: '16px', fontWeight: '600' }">Starr</div>
                      <div style="font-size: 12px; color: #7E8299;">Compliance Management</div>
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" :style="user_favourite && user_favourite.toUpperCase() === 'STARR' ? {
                          background: 'linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          backgroundClip: 'text'
                        } : {}" :color="user_favourite && user_favourite.toUpperCase() === 'STARR' ? '' : '#B5B5C3'"
                          size="20" class="mr-2" @click.stop="setFavouriteHost('STARR')">
                          {{ user_favourite && user_favourite.toUpperCase() === 'STARR' ? 'mdi-heart' :
                          'mdi-heart-outline' }}
                        </v-icon>
                      </template>
                      <span>{{ user_favourite && user_favourite.toUpperCase() === 'STARR' ? 'Remove from favourite' :
                        'Set as
                        favourite' }}</span>
                    </v-tooltip>
                    <v-icon v-if="selected_host === 'starr'" :style="{
                      background: 'linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    }">mdi-check-circle</v-icon>
                  </div>
                </div>
              </div>

              <!-- Board Host -->
              <div v-if="singleEntityData && singleEntityData.board_flag" class="selection-item mb-3 board-host-item"
                :style="{
                  borderRadius: '8px',
                  cursor: 'pointer',
                  background: selected_host === 'board' ? 'linear-gradient(90deg, rgba(255, 152, 0, 0.06) 0%, rgba(255, 87, 34, 0.06) 50%, rgba(244, 67, 54, 0.06) 100%)' : '#F3F6F9',
                  padding: '16px',
                  borderLeft: 'none',
                  boxShadow: selected_host === 'board' ? '0 2px 8px rgba(255, 87, 34, 0.12)' : 'none',
                  position: 'relative',
                  overflow: 'hidden'
                }" @click="selectHostForSingleEntity('board')">
                <div class="board-gradient-bar" :style="{
                  position: 'absolute',
                  left: '0',
                  top: '0',
                  bottom: '0',
                  width: '4px',
                  background: 'linear-gradient(180deg, #FF9800 0%, #FF5722 50%, #F44336 100%)'
                }"></div>
                <div class="d-flex align-center justify-space-between">
                  <div class="d-flex align-center">
                    <v-icon :style="selected_host === 'board' ? {
                      background: 'linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    } : {}" :color="selected_host === 'board' ? '' : '#7E8299'" size="24" class="mr-3">
                      {{ selected_host === 'board' ? 'mdi-star' : 'mdi-star-outline' }}
                    </v-icon>
                    <div>
                      <div class="selection-label host-label" :style="selected_host === 'board' ? {
                        background: 'linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        fontSize: '16px',
                        fontWeight: '600'
                      } : { fontSize: '16px', fontWeight: '600' }">
                        Board
                      </div>
                      <div style="font-size: 12px; color: #7E8299;">Board Management</div>
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" :style="user_favourite && user_favourite.toUpperCase() === 'BOARD' ? {
                          background: 'linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          backgroundClip: 'text'
                        } : {}" :color="user_favourite && user_favourite.toUpperCase() === 'BOARD' ? '' : '#B5B5C3'"
                          size="20" class="mr-2" @click.stop="setFavouriteHost('BOARD')">
                          {{ user_favourite && user_favourite.toUpperCase() === 'BOARD' ? 'mdi-heart' :
                          'mdi-heart-outline' }}
                        </v-icon>
                      </template>
                      <span>{{ user_favourite && user_favourite.toUpperCase() === 'BOARD' ? 'Remove from favourite' :
                        'Set as
                        favourite' }}</span>
                    </v-tooltip>
                    <v-icon v-if="selected_host === 'board'" :style="{
                      background: 'linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    }">mdi-check-circle</v-icon>
                  </div>
                </div>
              </div>

              <!-- FamilyBook Host -->
              <div v-if="singleEntityData && singleEntityData.family_book_flag"
                class="selection-item mb-3 familybook-host-item" :style="{
                  borderRadius: '8px',
                  cursor: 'pointer',
                  background: selected_host === 'familybook' ? 'linear-gradient(90deg, rgba(57, 130, 219, 0.06) 0%, rgba(87, 130, 199, 0.06) 50%, rgba(137, 83, 237, 0.06) 100%)' : '#F3F6F9',
                  padding: '16px',
                  borderLeft: 'none',
                  boxShadow: selected_host === 'familybook' ? '0 2px 8px rgba(87, 130, 199, 0.12)' : 'none',
                  position: 'relative',
                  overflow: 'hidden'
                }" @click="selectHostForSingleEntity('familybook')">
                <div class="familybook-gradient-bar" :style="{
                  position: 'absolute',
                  left: '0',
                  top: '0',
                  bottom: '0',
                  width: '4px',
                  background: 'linear-gradient(180deg, #3982DB 0%, #5782C7 50%, #8953ED 100%)'
                }"></div>
                <div class="d-flex align-center justify-space-between">
                  <div class="d-flex align-center">
                    <v-icon :style="selected_host === 'familybook' ? {
                      background: 'linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    } : {}" :color="selected_host === 'familybook' ? '' : '#7E8299'" size="24" class="mr-3">
                      {{ selected_host === 'familybook' ? 'mdi-star' : 'mdi-star-outline' }}
                    </v-icon>
                    <div>
                      <div class="selection-label host-label" :style="{
                        fontSize: '16px',
                        fontWeight: '600',
                        background: selected_host === 'familybook' ? 'linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%)' : 'none',
                        WebkitBackgroundClip: selected_host === 'familybook' ? 'text' : 'unset',
                        WebkitTextFillColor: selected_host === 'familybook' ? 'transparent' : '#3F4254',
                        backgroundClip: selected_host === 'familybook' ? 'text' : 'unset'
                      }">
                        Familybook
                      </div>
                      <div style="font-size: 12px; color: #7E8299;">Family Book Management</div>
                    </div>
                  </div>
                  <div class="d-flex align-center">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" :style="user_favourite && user_favourite.toUpperCase() === 'FAMILYBOOK' ? {
                          background: 'linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%)',
                          WebkitBackgroundClip: 'text',
                          WebkitTextFillColor: 'transparent',
                          backgroundClip: 'text'
                        } : {}"
                          :color="user_favourite && user_favourite.toUpperCase() === 'FAMILYBOOK' ? '' : '#B5B5C3'"
                          size="20" class="mr-2" @click.stop="setFavouriteHost('FAMILYBOOK')">
                          {{ user_favourite && user_favourite.toUpperCase() === 'FAMILYBOOK' ? 'mdi-heart' :
                          'mdi-heart-outline' }}
                        </v-icon>
                      </template>
                      <span>{{ user_favourite && user_favourite.toUpperCase() === 'FAMILYBOOK' ? 'Remove from favourite'
                        : 'Set
                        as favourite' }}</span>
                    </v-tooltip>
                    <v-icon v-if="selected_host === 'familybook'" :style="{
                      background: 'linear-gradient(90deg, #3982DB 0%, #5782C7 50%, #8953ED 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    }">mdi-check-circle</v-icon>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>

          <!-- Multi-Entity Scenario - Horizontal Flow Selection -->
          <v-row v-else class="horizontal-layout-container">
            <!-- Left Section: Entity Selection -->
            <v-col cols="12" :sm="hasCompanyDataForSelectedEntity ? 4 : 6" class="selection-column entity-section">
              <div class="section-title mb-3">Select Entity</div>
              <!-- NOTE (20261001091512): text search — groups can have 100 entities. -->
              <v-text-field
                v-if="entity_dataset.length > 5"
                v-model="entity_search"
                placeholder="Search entity"
                prepend-inner-icon="mdi-magnify"
                outlined dense hide-details clearable
                class="mb-3"
                autocomplete="off"
              ></v-text-field>
              <div class="selection-list entity-list">
                <div v-if="!filteredEntityDataset.length" class="text-caption grey--text px-2 py-4">
                  No entity matches "{{ entity_search }}"
                </div>
                <div
                  v-for="entity in filteredEntityDataset"
                  :key="'entity-' + entity.id"
                  class="selection-item mb-2" 
                  :style="{
                    borderRadius: '8px',
                    cursor: 'pointer',
                    background: entity_id === entity.id ? selectedEntityBg : '#F3F6F9',
                    padding: '12px 16px',
                    borderLeft: '4px solid #3F51B5',
                    boxShadow: entity_id === entity.id ? dynamicBoxShadow : 'none'
                  }" @click="selectEntity(entity)">
                  <div class="d-flex align-center">
                    <img :src="entity_id === entity.id
                      ? is_boardpage
                        ? require('@/assets/switch_company_icon/selected_company_radio_button_boardpage.svg')
                        : require('@/assets/switch_company_icon/selected_company_radio_button.svg')
                      : require('@/assets/switch_company_icon/ompany_radio_button.svg')" alt="Entity Radio"
                      class="mr-2" style="width: 14px; height: 14px; cursor: pointer;" />
                    <span class="selection-label entity-label">{{ entity.name }}</span>
                    <v-icon v-if="entity_id === entity.id" :color="themeColor" size="18"
                      class="ml-auto">mdi-check-circle</v-icon>
                  </div>
                </div>
              </div>
            </v-col>

            <!-- Vertical Divider -->
            <div class="vertical-divider d-none d-sm-block"></div>

            <!-- Middle Section: Company Selection (Only show if entity has companies) -->
            <v-col
              v-if="entity_id && selectedEntityData && selectedEntityData.company_arr && selectedEntityData.company_arr.length > 0"
              cols="12" sm="4" class="selection-column company-section">
              <div class="section-title mb-3">Select Company</div>
              <div class="selection-list company-list">
                <div v-for="(company, company_index) in selectedEntityData.company_arr" :key="'company-' + company.id"
                  class="selection-item mb-2" :style="{
                    borderRadius: '8px',
                    cursor: 'pointer',
                    background: company_id === company.id ? hexToRgba('#4CAF50', 0.12) : '#F3F6F9',
                    padding: '12px 16px',
                    borderLeft: company_id === company.id ? '4px solid #4CAF50' : '4px solid transparent',
                    boxShadow: company_id === company.id ? '0 2px 8px rgba(76, 175, 80, 0.2)' : 'none'
                  }" @click="selectCompany(company)">
                  <div class="d-flex align-center">
                    <img :src="company_id === company.id
                      ? is_boardpage ? require('@/assets/switch_company_icon/selected_company_radio_button_boardpage.svg')
                        : require('@/assets/switch_company_icon/selected_company_radio_button.svg')
                      : require('@/assets/switch_company_icon/ompany_radio_button.svg')" alt="Company Radio"
                      class="mr-2" style="width: 14px; height: 14px; cursor: pointer;" />
                    <span class="selection-label company-label">{{ company.name }}</span>
                    <v-icon v-if="company_id === company.id" color="#4CAF50" size="18"
                      class="ml-auto">mdi-check-circle</v-icon>
                  </div>
                </div>
              </div>
            </v-col>

            <!-- Vertical Divider before Host (only when company section exists) -->
            <div v-if="entity_id && hasCompanyDataForSelectedEntity && hasHostFlags"
              class="vertical-divider d-none d-sm-block">
            </div>

            <!-- Right Section: Host Selection -->
            <v-col v-if="hasHostFlags" cols="12" :sm="hasCompanyDataForSelectedEntity ? 4 : 6"
              class="selection-column host-section">
              <div class="section-title mb-3">Options</div>
              <div class="selection-list host-list">
                <!-- Starr Host -->
                <div v-if="selectedEntityData && selectedEntityData.starr_flag"
                  class="selection-item mb-2 starr-host-item" :style="{
                    borderRadius: '8px',
                    cursor: entity_id ? 'pointer' : 'not-allowed',
                    background: selected_host === 'starr' ? 'linear-gradient(90deg, rgba(233, 30, 99, 0.06) 0%, rgba(156, 39, 176, 0.06) 50%, rgba(63, 81, 181, 0.06) 100%)' : '#F3F6F9',
                    padding: '12px 16px',
                    borderLeft: 'none',
                    boxShadow: selected_host === 'starr' ? '0 2px 8px rgba(156, 39, 176, 0.12)' : 'none',
                    opacity: entity_id ? 1 : 0.6,
                    position: 'relative',
                    overflow: 'hidden'
                  }" @click="entity_id && selectedEntityData ? selectHost('starr', selectedEntityData) : null">
                  <div class="starr-gradient-bar" :style="{
                    position: 'absolute',
                    left: '0',
                    top: '0',
                    bottom: '0',
                    width: '4px',
                    background: 'linear-gradient(180deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)'
                  }"></div>
                  <div class="d-flex align-center">
                    <v-icon :style="selected_host === 'starr' ? {
                      background: 'linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    } : {}" :color="selected_host === 'starr' ? '' : '#7E8299'" size="18" class="mr-2">
                      {{ selected_host === 'starr' ? 'mdi-star' : 'mdi-star-outline' }}
                    </v-icon>
                    <span class="selection-label host-label" :style="selected_host === 'starr' ? {
                      background: 'linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    } : {}">Starr</span>
                    <v-icon v-if="selected_host === 'starr'" :style="{
                      background: 'linear-gradient(90deg, #E91E63 0%, #9C27B0 50%, #3F51B5 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    }" size="18" class="ml-auto">mdi-check-circle</v-icon>
                  </div>
                </div>

                <!-- Board Host -->
                <div v-if="selectedEntityData && selectedEntityData.board_flag"
                  class="selection-item mb-2 board-host-item" :style="{
                    borderRadius: '8px',
                    cursor: entity_id ? 'pointer' : 'not-allowed',
                    background: selected_host === 'board' ? 'linear-gradient(90deg, rgba(255, 152, 0, 0.06) 0%, rgba(255, 87, 34, 0.06) 50%, rgba(244, 67, 54, 0.06) 100%)' : '#F3F6F9',
                    padding: '12px 16px',
                    borderLeft: 'none',
                    boxShadow: selected_host === 'board' ? '0 2px 8px rgba(255, 87, 34, 0.12)' : 'none',
                    opacity: entity_id ? 1 : 0.6,
                    position: 'relative',
                    overflow: 'hidden'
                  }" @click="entity_id && selectedEntityData ? selectHost('board', selectedEntityData) : null">
                  <div class="board-gradient-bar" :style="{
                    position: 'absolute',
                    left: '0',
                    top: '0',
                    bottom: '0',
                    width: '4px',
                    background: 'linear-gradient(180deg, #FF9800 0%, #FF5722 50%, #F44336 100%)'
                  }"></div>
                  <div class="d-flex align-center">
                    <v-icon :style="selected_host === 'board' ? {
                      background: 'linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    } : {}" :color="selected_host === 'board' ? '' : '#7E8299'" size="18" class="mr-2">
                      {{ selected_host === 'board' ? 'mdi-star' : 'mdi-star-outline' }}
                    </v-icon>
                    <span class="selection-label host-label" :style="selected_host === 'board' ? {
                      background: 'linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    } : {}">Board</span>
                    <v-icon v-if="selected_host === 'board'" :style="{
                      background: 'linear-gradient(90deg, #FF9800 0%, #FF5722 50%, #F44336 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    }" size="18" class="ml-auto">mdi-check-circle</v-icon>
                  </div>
                </div>
                <!-- FamilyBook Host -->
                <div v-if="selectedEntityData && selectedEntityData.family_book_flag" class="selection-item mb-2"
                  :style="{
                    borderRadius: '8px',
                    cursor: entity_id ? 'pointer' : 'not-allowed',
                    background: selected_host === 'familybook' ? hexToRgba('#FF9800', 0.12) : '#F3F6F9',
                    padding: '12px 16px',
                    borderLeft: '4px solid #FF9800',
                    boxShadow: selected_host === 'familybook' ? '0 2px 8px rgba(255, 152, 0, 0.2)' : 'none',
                    opacity: entity_id ? 1 : 0.6
                  }" @click="entity_id && selectedEntityData ? selectHost('familybook', selectedEntityData) : null">
                  <div class="d-flex align-center">
                    <v-icon :color="selected_host === 'familybook' ? '#FF9800' : '#7E8299'" size="18" class="mr-2">
                      {{ selected_host === 'familybook' ? 'mdi-star' : 'mdi-star-outline' }}
                    </v-icon>
                    <span class="selection-label host-label">Familybook</span>
                    <v-icon v-if="selected_host === 'familybook'" color="#FF9800" size="18"
                      class="ml-auto">mdi-check-circle</v-icon>
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="proceed-actions-fixed">
          <!-- Cancel Button -->
          <v-btn class="cancel-btn mr-3" outlined :color="themeColor" @click="cancelSelection">
            Cancel
          </v-btn>
          <!-- Proceed Button -->
          <v-btn class="proceed-btn" :color="themeColor"
            :disabled="isSingleEntityScenario ? !selected_host : !entity_id" @click="proceedWithSelection">
            {{ isSingleEntityScenario ? 'Switch Host' : 'Proceed' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Package from "/package.json";
import moment from "moment";
import { invalidateTokenOnLogout } from "@/services/loginHelper.js";
export default {
  mounted: function () {
    this.app_version();
    const hostname = window.location.hostname;
    const pathname = window.location.pathname;
    let is_boardpage = false;
    this.onLoadDataset();
    this.username = localStorage.getItem("USER_NAME");
    this.entity_name = localStorage.getItem("entity_name");
    this.entity_id = parseInt(localStorage.getItem("ENTITY_ID"));
    this.entity_ID = parseInt(localStorage.getItem("ENTITY_ID"));
    this.entity_id_list = localStorage.getItem("USER_ENTITY_DATASET");
    this.entityData = localStorage.getItem("entitydata");
    this.entity__Data = JSON.parse(this.entityData) ? (JSON.parse(this.entityData).length ? JSON.parse(this.entityData) : []) : [];
    this.$emit("entity___Data_fn", this.entity__Data);
    if (hostname.includes('myboardpage')) {
      is_boardpage = true;
    } else {
      is_boardpage = false;
    }
    localStorage.setItem('is_boardpage', is_boardpage.toString());
    if (!["admin", "devadmin"].includes(this.domain)) {
      if (!this.entity_ID && (JSON.parse(this.entityData) ? JSON.parse(this.entityData).length > 1 : false)) {
        this.switch_entity();
      } else if (this.entityData && JSON.parse(this.entityData).length === 1) {
        let enty = JSON.parse(this.entityData);
        localStorage.setItem("ENTITY_ID", enty[0].id);
        localStorage.setItem("entity_name", enty[0].name);
        this.entity_ID = localStorage.getItem("ENTITY_ID");
      }
    }
    this.$emit("entity__id_fn", this.entity_ID);
    this.expiry_date = localStorage.getItem("expiry_date");
    this.current_date = moment().format("YYYY-MM-DD");
    this.diff_date = moment(this.expiry_date).diff(this.current_date, "days");
    if (this.diff_date < 3) {
      this.badge_flag = true;
    }
  },
  data: () => (
    {
      applicationVersion: Package.version,
      resultat: localStorage.getItem("resultat"),
      menu: false,
      checkFMS: localStorage.hasOwnProperty("tectalik_product_list") ? localStorage.getItem("tectalik_product_list").includes("TECTALIK_FMS") : false,
      overlay_load: false,
      url_break: [],
      entity_name: null,
      entity_id: null,
      survey_walkin: false,
      domain: localStorage.getItem("domain"),
      switch_dialog: false,
      switch_tabs_dialog: false,
      active_tab: 0,
      entity_ID: null,
      entityData: null,
      entity_dataset: [],
      entity_search: "",
      company_data_arr: [],
      host_obj: { starr_flag: false, board_flag: false, family_book_flag: false },
      company_id: null,
      company_dataset: [],
      selected_host: null,
      has_company_data: false,
      user_starr_flag: false,
      user_board_flag: false,
      user_family_book_flag: false,
      user_favourite: null,
      // Favourite confirmation dialog
      favouriteConfirmDialog: false,
      pendingFavouriteHost: null,
      user: true,
      getuser: [],
      device_token: null,
      user_name: localStorage.getItem("USER_NAME"),
      user_id: localStorage.getItem("USER_ID"),
      branch_ID: localStorage.getItem("BRANCH_ID"),
      is_boardpage: window.location.hostname.includes('myboardpage'),
      drawer: false,
      items: [],
      mini: false,
      dialog: false,
      value: false,
      showimage: false,
      show_hide_mob_btn: 0,
      full_or_modal: 0,
      window: {
        width: 0,
        height: 0,
      },
      iflag: 0,
      logged_user_Email: localStorage.getItem("USER_EMAIL"),
      old_token: localStorage.getItem("TOKEN"),
      expiry_date: null,
      current_date: null,
      diff_date: null,
      survey_flag: false,
      badge_flag: false,
      hostname: window.location.hostname,

      entity__Data: [],
    }
  ),
  watch: {
    // Fresh search every time Switch Options opens.
    switch_tabs_dialog(open) {
      if (open) this.entity_search = "";
    },
  },
  computed: {
    isComplianceDomain() {
      const hostname = window.location.hostname;
      return hostname.includes('compliance') || hostname.includes('tectalik');
    },
    listBackgroundClass() {
      const hostname = window.location.hostname;
      if (hostname.includes('myboardpage')) {
        return 'myboardpage-background';
      } else if (hostname.includes('compliance') || hostname.includes('tectalik')) {
        return 'compliance-background';
      }
      return '';  // Default empty string
    },
    themeColor() {
      return this.is_boardpage ? "#ffa500" : "#4318ff";
    },
    selectedEntityBg() {
      // Use a translucent version of the theme color for the background
      return this.hexToRgba(this.themeColor, 0.12);
    },
    dynamicBoxShadow() {
      // You can adjust the opacity as needed (e.g., 0.15)
      return `0 2px 8px ${this.hexToRgba(this.themeColor, 0.15)}`;
    },
    // Entity list filtered by the Switch Options search box.
    filteredEntityDataset() {
      return (this.entity_dataset || []).filter((e) =>
        this.global_text_match(e.name, this.entity_search)
      );
    },
    isSingleEntityScenario() {
      // Single entity scenario: entity_id exists in localStorage and only 1 entity in dataset
      const hasEntityInStorage = !!localStorage.getItem("ENTITY_ID");
      const hasSingleEntity = this.entity_dataset && this.entity_dataset.length === 1;
      return hasEntityInStorage && hasSingleEntity;
    },
    singleEntityName() {
      // Get entity name from localStorage
      return localStorage.getItem("entity_name") || 'Unknown Entity';
    },
    singleEntityData() {
      // Get the single entity data when in single entity scenario
      if (this.entity_dataset && this.entity_dataset.length === 1) {
        return this.entity_dataset[0];
      }
      return null;
    },
    selectedEntityData() {
      // Get the currently selected entity data
      if (!this.entity_id || !this.entity_dataset) return null;
      return this.entity_dataset.find(e => e.id === this.entity_id) || null;
    },
    hasCompanyDataForSelectedEntity() {
      // Check if selected entity has company data
      return this.selectedEntityData &&
        this.selectedEntityData.company_arr &&
        Array.isArray(this.selectedEntityData.company_arr) &&
        this.selectedEntityData.company_arr.length > 0;
    },
    hasHostFlags() {
      // Check if selected entity has any host flags
      if (this.selectedEntityData) {
        const hasFlags = this.selectedEntityData.starr_flag || this.selectedEntityData.board_flag || this.selectedEntityData.family_book_flag;
        console.log('hasHostFlags check:', {
          selectedEntity: this.selectedEntityData.name,
          starr_flag: this.selectedEntityData.starr_flag,
          board_flag: this.selectedEntityData.board_flag,
          family_book_flag: this.selectedEntityData.family_book_flag,
          hasFlags: hasFlags
        });
        return hasFlags;
      }
      console.log('hasHostFlags: no selectedEntityData');
      return false;
    },
  },
  methods: {
    /**
     * Fetch master data for the current entity
     * Called when entity is selected or changed
     */
    async fetchMasterDataForEntity() {
      const entityId = localStorage.getItem("ENTITY_ID");
      if (!entityId) {
        console.warn('[OldHomeFunctions] No entity ID found, skipping master data fetch');
        return;
      }

      try {
        console.log('[OldHomeFunctions] Fetching master data for entity:', entityId);
        // await this.$store.dispatch('F/fetchMasterData');
        // console.log('[OldHomeFunctions] Master data fetched successfully');
      } catch (error) {
        console.error('[OldHomeFunctions] Failed to load master data:', error);
        // Don't show error toast as this is background operation
      }
      this.overlay_load = false;
    },
    setFavouriteHost(host) {
      // If clicking on already selected favourite, remove it directly without confirmation
      if (this.user_favourite && this.user_favourite.toUpperCase() === host) {
        this.confirmRemoveFavourite();
        return;
      }
      // Show confirmation dialog for setting favourite
      this.pendingFavouriteHost = host;
      this.favouriteConfirmDialog = true;
    },
    confirmSetFavourite() {
      const host = this.pendingFavouriteHost;
      let prefix = "cmp_" + this.domain;
      prefix = prefix == "cmp_admin" ? "public" : prefix;

      const user_dataset = {
        user_dataset: {
          favourite: host
        }
      };

      this.$api.put("/update_user_favourite/" + this.user_id + "/" + prefix, user_dataset)
        .then((response) => {
          this.user_favourite = host;
          this.favouriteConfirmDialog = false;
          this.pendingFavouriteHost = null;
          this.$toast.success(`${host} set as favourite. You will be redirected to ${host} after login.`);
        })
        .catch((err) => {
          console.error("Error updating favourite:", err);
          this.$toast.error('Failed to update favourite');
          this.favouriteConfirmDialog = false;
          this.pendingFavouriteHost = null;
        });
    },
    confirmRemoveFavourite() {
      let prefix = "cmp_" + this.domain;
      prefix = prefix == "cmp_admin" ? "public" : prefix;

      const user_dataset = {
        user_dataset: {
          favourite: null
        }
      };

      this.$api.put("/update_user_favourite/" + this.user_id + "/" + prefix, user_dataset)
        .then((response) => {
          this.user_favourite = null;
          this.$toast.success('Favourite removed');
        })
        .catch((err) => {
          console.error("Error removing favourite:", err);
          this.$toast.error('Failed to remove favourite');
        });
    },
    cancelFavouriteDialog() {
      this.favouriteConfirmDialog = false;
      this.pendingFavouriteHost = null;
    },
    hexToRgba(hex, alpha) {
      let r = 0, g = 0, b = 0;
      if (hex.length === 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
      } else if (hex.length === 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
      }
      return `rgba(${+r},${+g},${+b},${alpha})`;
    },
    refresh_token() {
      axios.post("/update_refresh_token/" + this.old_token).then((response) => {
        localStorage.removeItem("TOKEN");
        localStorage.setItem("TOKEN", response.data.new_token);
        let tkn = localStorage.getItem("TOKEN");
        this.update_user_data();
      }).catch((err) => { });
    },
    getDomainColor() {
      const currentDomain = window.location.hostname;
      if (currentDomain.includes('compliance') || currentDomain.includes('tectalik')) {
        return 'orange';
      } else if (currentDomain.includes('myboardpage')) {
        return 'black';
      } else {
        return 'orange';
      }
    },
    update_user_data() {
      let prefix = "cmp_" + this.domain;
      prefix = prefix == "cmp_admin" ? "public" : prefix;
      const user_dataset = {
        user_dataset: {
          logged_date: moment(),
          expiry_date: moment().add(7, "days"),
        },
      };
      this.$api.put("/update_user_logged_data/" + this.user_id + "/" + prefix, user_dataset).then((response) => {
        let expiry_date = moment().add(7, "days").format("YYYY-MM-DD");
        localStorage.removeItem("expiry_date");
        localStorage.setItem("expiry_date", expiry_date);
        const name = localStorage.getItem("expiry_date");
        this.badge_flag = false;
      }).catch((error) => {
        console.log(error, "error");
      });
    },
    store_token() {
      const user_id = parseInt(this.user_id);
      const params = {
        params: {
          device_token: this.device_token,
        },
      };
      this.$api.put("update_users_device_logout/" + user_id, params)
        .catch((err) => console.log(err))
        .finally(() => {
          this.clearStorage();
        });
    },
    async clearStorage() {
      await invalidateTokenOnLogout();
      localStorage.removeItem("ENTITY_ID");
      localStorage.removeItem("TOKEN");
      localStorage.clear();
      this.$router.push({ path: "/login" });
    },
    open_ticket() {
      this.dialog = false;
      this.$router.push("ticket");
    },
    open_checklist() {
      this.dialog = false;
      this.$router.push("MainChecklist");
    },
    open_survey() {
      this.dialog = false;
      this.$router.push("survey");
    },
    open_visit() {
      this.dialog = false;
      this.$router.push("/visits/landing");
    },
    open_walkins() {
      this.dialog = false;
      this.$router.push("/walkin/landing");
    },
    incentive_report() {
      this.dialog = false;
      this.$router.push("incentive_reports");
    },
    actual_report() {
      this.dialog = false;
      this.$router.push("actual_reports");
    },
    survey_report() {
      this.dialog = false;
      this.$router.push("survey_reports");
    },
    visit_report() {
      this.dialog = false;
      this.$router.push("visitReport");
    },
    walkins_report() {
      this.dialog = false;
      this.$router.push("/walkins/reports");
    },
    ticket_report() {
      this.dialog = false;
      this.$router.push("tickets_report");
    },
    checklist_report() {
      this.dialog = false;
      this.$router.push("showlist_all_report");
    },
    addsurvey() {
      this.dialog = false;
      this.$router.push("/survey/add");
    },
    addgoals() {
      this.dialog = false;
      this.$router.push({ path: "business_plan", query: { flag: "add" } });
    },
    addwalkins() {
      this.dialog = false;
      this.$router.push({ path: "/walkin/landing", query: { flag: "add" } });
    },
    planvisit() {
      this.dialog = false;
      this.$router.push({
        path: "/visits/landing",
        query: { flag: "planadd" },
      });
    },
    logvisit() {
      this.dialog = false;
      this.$router.push({ path: "/visits/landing", query: { flag: "add" } });
    },
    mainchecklist() {
      this.dialog = false;
      this.$router.push({ path: "MainChecklist", query: { flag: "added" } });
    },
    addkpi(flag) {
      this.dialog = false;
      this.$router.push("kpi_addition_tenant");
    },
    close_ticket() {
      this.dialog = false;
      this.$router.push("/ticket/add");
    },
    addService() {
      this.dialog = false;
      this.$router.push("/service/add");
    },
    addServiceCategory() {
      this.dialog = false;
      this.$router.push("/servicecategory/add");
    },
    add_employee() {
      this.dialog = false;
      this.$router.push("/employee_mstr/add");
    },
    getentityname(name) {
      localStorage.setItem("entity_name", name);
    },
    getcompanyname(name) {
      localStorage.setItem("company_name", name);
    },
    fetch_company_data(entity_id) {
      // Use provided entity_id or fall back to localStorage
      const id = entity_id || localStorage.getItem("ENTITY_ID");

      if (!id) {
        console.warn("No entity_id found");
        this.has_company_data = false;
        this.company_dataset = [];
        return;
      }

      axios.get(`get_company_master_landing_active_data/${id}`)
        .then((response) => {
          // console.log(response.data, "company_data");
          if (response.data.status === "success" && response.data.data && response.data.data.length > 0) {
            this.company_dataset = response.data.data.map(company => ({
              id: company.id,
              name: company.company_name
            }));
            this.has_company_data = true;
          } else {
            this.company_dataset = [];
            this.has_company_data = false;
          }
        })
        .catch((error) => {
          console.error("Error fetching company data:", error);
          this.has_company_data = false;
          this.company_dataset = [];
        });
    },
    fetch_user_flags() {
      // Fetch user data to get page_type flags
      const userId = this.user_id || localStorage.getItem("USER_ID");

      if (!userId) {
        console.warn("No user_id found");
        return;
      }

      axios.get(`users/${userId}`)
        .then((response) => {
          if (response.data && response.data.data) {
            const userData = response.data.data;

            // Set flags from user data
            this.user_starr_flag = userData.starr_flag || false;
            this.user_board_flag = userData.board_flag || false;
            this.user_family_book_flag = userData.family_book_flag || false;
          }
        })
        .catch((error) => {
          console.error("Error fetching user data:", error);
          // Default to false if error
          this.user_starr_flag = false;
          this.user_board_flag = false;
          this.user_family_book_flag = false;
        });
    },
    selectEntity(entity) {
      this.entity_id = entity.id;
      this.getentityname(entity.name);
      localStorage.setItem("ENTITY_ID", entity.id);
      this.company_id = null;
      this.selected_host = null;
      this.autoSelectHost();

      // Fetch master data for the newly selected entity
      this.$nextTick(() => {
        this.fetchMasterDataForEntity();
      });
    },
    selectCompany(company) {
      console.log("Selected company:", company);
      console.log("Company ID:", company.id, "Type:", typeof company.id);
      console.log("All companies:", this.selectedEntityData?.company_arr);

      // Ensure we're setting a proper value
      this.company_id = company.id;
      this.getcompanyname(company.name);
      localStorage.setItem("COMPANY_ID", company.id);
      localStorage.setItem("company_name", company.name);

      console.log("After selection - company_id:", this.company_id);
    },
    selectHost(host, entity) {
      // No user-level validation - host options are shown based on entity flags only
      this.selected_host = host;
      // Save selected host to localStorage
      localStorage.setItem("SELECTED_HOST", host);
      localStorage.setItem("selected_host_flag", host);

      // Set is_family_book flag for routing logic
      if (host === 'familybook') {
        localStorage.setItem("is_family_book", "true");
      } else {
        localStorage.setItem("is_family_book", "false");
      }
    },
    selectHostForSingleEntity(host) {
      // No user-level validation - host options are shown based on entity flags only
      this.selected_host = host;
      // Save selected host to localStorage
      localStorage.setItem("SELECTED_HOST", host);
      localStorage.setItem("selected_host_flag", host);

      // Set is_family_book flag for routing logic
      if (host === 'familybook') {
        localStorage.setItem("is_family_book", "true");
      } else {
        localStorage.setItem("is_family_book", "false");
      }
    },
    isSingleCompany(entity) {
      const isSingleEntity = this.entity_dataset && this.entity_dataset.length === 1;
      const isSingleOrNoCompany = !entity.company_arr || entity.company_arr.length === 0 || entity.company_arr.length === 1;
      return isSingleEntity || isSingleOrNoCompany;
    },
    clearEntitySelection() {
      // Clear entity selection to allow user to choose a different entity
      this.entity_id = null;
      this.company_id = null;
      this.selected_host = null;
      // Clear from localStorage
      localStorage.removeItem("ENTITY_ID");
      localStorage.removeItem("entity_name");
      localStorage.removeItem("COMPANY_ID");
      localStorage.removeItem("company_name");
      localStorage.removeItem("SELECTED_HOST");
      localStorage.removeItem("selected_host_flag");
      // Force UI update to show entity selection
      this.$forceUpdate();
    },
    cancelSelection() {
      // Close the dialog without making any changes
      this.switch_tabs_dialog = false;
      // Clear the session flag to allow dialog to show again if needed
      sessionStorage.removeItem("host_dialog_shown");
    },
    proceedWithSelection() {
      this.overlay_load = true;
      if (this.isSingleEntityScenario) {
        // For single entity, use entity_id from localStorage
        const storedEntityId = localStorage.getItem("ENTITY_ID");

        if (!storedEntityId) {
          this.$toast.error('Entity ID not found');
          this.overlay_load = false;
          return;
        }

        if (!this.selected_host) {
          this.$toast.error('Please select a host');
          this.overlay_load = false;
          return;
        }

        // No user-level validation - host options are shown based on entity flags only

        // Set entity_id for single entity scenario
        this.entity_id = parseInt(storedEntityId);

        // Save company data to localStorage if selected
        if (this.company_id) {
          localStorage.setItem("COMPANY_ID", this.company_id);
          // Find and save company name
          const selectedCompany = this.company_dataset.find(c => c.id === this.company_id);
          if (selectedCompany) {
            localStorage.setItem("company_name", selectedCompany.name);
          }
        }

        // Check if selected host matches current page
        const currentHostname = window.location.hostname;
        const isSameHost = this.isSameHostAsCurrentPage(this.selected_host, currentHostname);

        if (isSameHost) {
          console.log('Selected host matches current page - using normal login');
          this.login();
        } else {
          console.log('Opening new tab for different host:', this.selected_host);
          this.openHostInNewTab();
        }
        return;
      }

      // Multi-entity scenario validation
      if (!this.entity_id) {
        this.$toast.error('Please select an entity');
        this.overlay_load = false;
        return;
      }

      // Get the selected entity
      const selectedEntity = this.entity_dataset.find(e => e.id === this.entity_id);

      if (!selectedEntity) {
        this.$toast.error('Selected entity not found');
        this.overlay_load = false;
        return;
      }

      // SCENARIO 1: Auto-select host if entity has access to only one host
      const availableHosts = [selectedEntity.starr_flag, selectedEntity.board_flag, selectedEntity.family_book_flag].filter(Boolean);
      if (availableHosts.length === 1 && !this.selected_host) {
        console.log('SCENARIO 1: Auto-selecting single available host for entity');

        // Auto-select the only available host for this entity
        if (selectedEntity.starr_flag) {
          this.selected_host = 'starr';
        } else if (selectedEntity.board_flag) {
          this.selected_host = 'board';
        } else if (selectedEntity.family_book_flag) {
          this.selected_host = 'familybook';
        }

        // Save to localStorage
        if (this.selected_host) {
          localStorage.setItem("SELECTED_HOST", this.selected_host);
          localStorage.setItem("selected_host_flag", this.selected_host);
          if (this.selected_host === 'familybook') {
            localStorage.setItem("is_family_book", "true");
          } else {
            localStorage.setItem("is_family_book", "false");
          }
        }
      }

      // Validate host selection and user access
      if (this.selected_host) {
        // No user-level validation - host options are shown based on entity flags only

        // Check if selected host matches current page
        const currentHostname = window.location.hostname;
        const isSameHost = this.isSameHostAsCurrentPage(this.selected_host, currentHostname);

        if (isSameHost) {
          console.log('Selected host matches current page - using normal login');
          // If we're already on the selected host, just reload current page
          this.login();
        } else {
          console.log('Opening new tab for different host:', this.selected_host);
          // If different host selected, open in new tab
          this.openHostInNewTab();
        }
      } else {
        console.log('No host selected, using normal login');
        // If no host selected, proceed with normal login
        this.login();
      }
    },
    isSameHostAsCurrentPage(selectedHost, currentHostname) {
      // Check if the selected host matches the current page we're ACTUALLY on
      // Must check current route and hostname, NOT stored selection (as that may have just been changed)
      const currentPath = this.$route ? this.$route.path : '';
      const isFamilyBookRoute = currentPath.includes('familybook');

      switch (selectedHost) {
        case 'board':
          // Check if we're ACTUALLY on board (not familybook route and hostname matches)
          return currentHostname.includes('myboardpage') && !isFamilyBookRoute;
        case 'starr':
          // Check if we're ACTUALLY on starr (not familybook route and hostname matches)
          // NOTE (20260926052418): starrboard.* is the STARR app too — without it
          // a same-app switch took the "open new tab" path.
          return (currentHostname.includes('compliance') || currentHostname.includes('tectalik') || currentHostname.includes('starrboard')) && !isFamilyBookRoute;
        case 'familybook':
          // Familybook can be accessed from the same host (board or compliance)
          // So we return true if we're on a compatible hostname, to use login() instead of opening new tab
          return currentHostname.includes('myboardpage') || currentHostname.includes('compliance') || currentHostname.includes('tectalik');
        default:
          return false;
      }
    },
    // NOTE (20260926052418): Re-mint an entity-bound token for `entityId` so
    // the token's signed `ent` claim matches the entity the next requests ask
    // for (AuthorizeRequest rejects a mismatch with ERR_AUTH_002). Shared by
    // login() and openHostInNewTab() — the latter never re-minted, so on hosts
    // not matched by isSameHostAsCurrentPage (e.g. starrboard.in) every switch
    // failed with "Your session does not match the requested company".
    // Returns true only when the new token is stored.
    async remintTokenForEntity(entityId) {
      try {
        const _sw = await this.$papi.post("sessions/switch_entity", {
          email: localStorage.getItem("USER_EMAIL"),
          entity_id: entityId,
        });
        if (!(_sw && _sw.data && _sw.data.token)) throw new Error("no token returned");
        localStorage.setItem("TOKEN", _sw.data.token);
        return true;
      } catch (e) {
        console.warn("[switch entity] failed:", e && e.message);
        const msg = (e && e.response && e.response.data && e.response.data.message) ||
          "Could not switch to this company. Please contact your administrator.";
        if (typeof this.global_push_toast === "function") this.global_push_toast("error", msg);
        this.entity_id = Number(localStorage.getItem("ENTITY_ID")) || this.entity_id;
        this.overlay_load = false;
        return false;
      }
    },
    async openHostInNewTab() {

      // First, save the selections and get entity data
      if (isNaN(this.entity_id) == true || this.entity_id == null) {
        console.error('Invalid entity_id:', this.entity_id);
        return;
      }

      // Token must match the new entity before any entity-scoped request.
      if (!(await this.remintTokenForEntity(this.entity_id))) return;

      localStorage.setItem("ENTITY_ID", this.entity_id);
      if (this.company_id) {
        localStorage.setItem("COMPANY_ID", this.company_id);
      }

      var url_string = "";
      var url_break = window.location.pathname.split("/");
      url_break = url_break[1];
      if (
        url_break == "checklist_Template_page" ||
        url_break == "kpi_additions" ||
        url_break == "templatelibrary" ||
        url_break == "appraisal_add"
      ) {
        url_string = "tapi/";
      }

      axios
        .get(url_string + "get_email_by_entity", {
          params: {
            email: localStorage.getItem("USER_EMAIL"),
            entity_id: this.entity_id,
            user_id: this.user_id,
          },
        })
        .then((response) => {
          let family_office_flag = response.data.data.family_office_flag;
          let family_tree_flag = response.data.data.family_tree_flag;
          localStorage.setItem("family_office_flag", family_office_flag);
          localStorage.setItem("family_tree_flag", family_tree_flag);

          // Store necessary data
          const customer = response.data.customer;
          if (Array.isArray(customer) && customer.length > 0) {
            localStorage.setItem("CUSTOMER_LIST", JSON.stringify(customer[0]));
          }

          let employee_dataset = response.data.emp_details;

          // Set local storage data for other settings
          let rating_setting = response.data.rating_setting;
          if (rating_setting.length) {
            let self_rating_setting = rating_setting[0].self_rating ? "yes" : "no";
            localStorage.setItem("Self_Rating_Setting", self_rating_setting);
          } else {
            localStorage.setItem("Self_Rating_Setting", "yes");
          }

          let calc_settings = response.data.calc_settings;
          if (calc_settings.length) {
            let calc = calc_settings[0].show == true ? "yes" : "no";
            localStorage.setItem("kpi_calc", calc);
          } else {
            localStorage.setItem("kpi_calc", "yes");
          }

          if (employee_dataset.length) {
            localStorage.setItem("LOGGED_EMP_ID", employee_dataset[0].id);
            localStorage.setItem("LOGGED_EMP_NO", employee_dataset[0].empno);
          } else {
            localStorage.setItem("LOGGED_EMP_ID", 0);
            localStorage.setItem("LOGGED_EMP_NO", 0);
          }

          let pl = [];
          let product_list = [];
          let product_list_item = response.data.products_by_users;
          if (product_list_item.length != 0) {
            pl = product_list_item.map((a) => a.product_code);
          } else {
            pl = response.data.data.product_list;
          }

          if (pl == "" || pl == null) {
            product_list = [];
          } else {
            product_list = pl;
          }

          localStorage.setItem("tectalik_product_list", product_list);
          this.set_local_storage(response.data.modules_by_users, response.data.screen_by_users);
          localStorage.setItem("USER_ID", response.data.data.id);
          localStorage.setItem("USER_NAME", response.data.data.name);
          localStorage.setItem("BRANCH_ID", response.data.data.branch_id);
          localStorage.setItem("IS_ADMIN", response.data.is_admin.toString());
          localStorage.setItem("APPRAISAL_PERIOD_MSTR", JSON.stringify(response.data.appraisal_period_mstr));

          // Open new tab with appropriate URL based on selected host and environment
          const domain = this.domain || localStorage.getItem("domain");
          const node_env = (process.env.NODE_ENV || 'development').toLowerCase().trim();
          const hostname = window.location.hostname.toLowerCase();

          let baseUrl = '';

          // Generate URL based on environment and selected host
          if (this.selected_host === 'board') {
            if (node_env === 'production') {
              baseUrl = `https://${domain}.myboardpage.com/`;
            } else if (node_env === 'development') {
              baseUrl = `https://${domain}.staging.myboardpage.com/`;
            } else {
              // local environment
              baseUrl = `http://${domain}.myboardpage:8080/`;
            }
          } else if (this.selected_host === 'starr') {
            if (hostname.includes('starrboard')) {
              // STARRboard deployment — all tenants share the same domain, no subdomain routing.
              // Stay on the current origin so the #auth= hash is processed by the same app instance.
              baseUrl = `${window.location.origin}/`;
            } else if (node_env === 'production') {
              baseUrl = `https://${domain}.tectalik.com/`;
            } else if (node_env === 'development') {
              baseUrl = `https://${domain}.compliance-staging.tectalik.com/`;
            } else {
              // local environment
              baseUrl = `http://${domain}.compliance:8080/`;
            }
          } else if (this.selected_host === 'familybook') {
            // Familybook uses the same host but adds /familybook route
            localStorage.setItem("is_family_book", "true");
            if (hostname.includes('starrboard')) {
              // STARRboard deployment — stay on current origin
              baseUrl = `${window.location.origin}/`;
            } else if (node_env === 'production') {
              if (hostname.includes('board') || hostname.includes('myboardpage')) {
                baseUrl = `https://${domain}.myboardpage.com/`;
              } else {
                baseUrl = `https://${domain}.tectalik.com/`;
              }
            } else if (node_env === 'development') {
              if (hostname.includes('board') || hostname.includes('myboardpage')) {
                baseUrl = `https://${domain}.staging.myboardpage.com/`;
              } else {
                baseUrl = `https://${domain}.compliance-staging.tectalik.com/`;
              }
            } else {
              // local environment
              if (hostname.includes('myboardpage')) {
                baseUrl = `http://${domain}.myboardpage:8080/`;
              } else {
                baseUrl = `http://${domain}.compliance:8080/`;
              }
            }
            localStorage.setItem("is_family_book", "true");
          } else {
            console.error('Unknown host:', this.selected_host);
            baseUrl = '';
          }
          if (baseUrl) {
            // Prepare localStorage data to transfer to new tab
            const localStorageData = {
              TOKEN: localStorage.getItem("TOKEN"),
              USER_ID: response.data.data.id,
              USER_NAME: response.data.data.name,
              USER_EMAIL: localStorage.getItem("USER_EMAIL"),
              ENTITY_ID: this.entity_id,
              entity_name: localStorage.getItem("entity_name"),
              BRANCH_ID: response.data.data.branch_id,
              IS_ADMIN: response.data.is_admin.toString(),
              domain: domain,
              USER_DESIGNATION: localStorage.getItem("USER_DESIGNATION"),
              LOGGED_EMP_ID: localStorage.getItem("LOGGED_EMP_ID") || (employee_dataset.length ? employee_dataset[0].id : 0),
              LOGGED_EMP_NO: localStorage.getItem("LOGGED_EMP_NO") || (employee_dataset.length ? employee_dataset[0].empno : 0),
              tectalik_product_list: product_list.toString(),
              MODULE_RIGHTS_DATASET: JSON.stringify(response.data.modules_by_users),
              SCREEN_RIGHT_DATASET: localStorage.getItem("SCREEN_RIGHT_DATASET"),
              Self_Rating_Setting: localStorage.getItem("Self_Rating_Setting"),
              kpi_calc: localStorage.getItem("kpi_calc"),
              CUSTOMER_LIST: localStorage.getItem("CUSTOMER_LIST"),
              APPRAISAL_PERIOD_MSTR: JSON.stringify(response.data.appraisal_period_mstr),
              expiry_date: localStorage.getItem("expiry_date"),
              entitydata: localStorage.getItem("entitydata"),
              is_boardpage: this.selected_host === 'board' ? 'true' : 'false',
              logoUrl: localStorage.getItem("logoUrl"),
              resultat: localStorage.getItem("resultat"),
              COMPANY_ID: this.company_id || '',
              company_name: localStorage.getItem("company_name") || '',
              SELECTED_HOST: this.selected_host,
              is_family_book: this.selected_host === 'familybook' ? 'true' : 'false',
              SUBSCRIPTION_STATUS:   localStorage.getItem("SUBSCRIPTION_STATUS")    || 'TRIAL',
              TRIAL_ENDS_AT:         localStorage.getItem("TRIAL_ENDS_AT")          || '',
              TRIAL_EXTENSION_COUNT: localStorage.getItem("TRIAL_EXTENSION_COUNT")  || '0',
              SUBSCRIPTION_END_DATE: localStorage.getItem("SUBSCRIPTION_END_DATE")  || ''
            };

            // Encode data as URL parameter
            const encodedData = btoa(encodeURIComponent(JSON.stringify(localStorageData)));

            // For familybook, add the /familybook/FamilyDashboard route to the URL
            let fullUrl = '';
            if (this.selected_host === 'familybook') {
              if (family_office_flag == true) {
                fullUrl = `${baseUrl}familybook/Family_Forms#auth=${encodedData}`;
              } else if (family_tree_flag == true) {
                fullUrl = `${baseUrl}familybook/FamilyDashboard#auth=${encodedData}`;
              } else {
                fullUrl = `${baseUrl}familybook/FamilyDashboard#auth=${encodedData}`;
              }
            } else {
              fullUrl = `${baseUrl}#auth=${encodedData}`;
            }

            // Open new tab with encoded data
            const newWindow = window.open(fullUrl, '_blank');

            if (newWindow) {
              console.log('New tab opened successfully!');
              // Mark that user has completed host/entity selection
              sessionStorage.setItem("host_dialog_shown", "true");
            } else {
              console.error('Failed to open new tab - popup might be blocked!');
              alert('Please allow popups for this site to open the new tab.');
            }

            // Close the dialog and hide loading overlay
            this.switch_tabs_dialog = false;
            this.overlay_load = false;
          } else {
            console.error('BaseUrl is empty! Cannot open new tab.');
            this.overlay_load = false;
          }
        })
        .catch((error) => {
          console.error("Error in openHostInNewTab API call:", error);
          console.error("Error details:", error.response || error.message);
          this.overlay_load = false;
        });
    },
    goToNextTab() {
      if (this.active_tab < 2) {
        this.active_tab++;
      }
    },
    backupstick() {
      this.$router.push("/fms_home");
    },
    backups() {
      var product_get = localStorage.getItem("tectalik_product_list");
      let product_list = [];
      if (
        product_get != null &&
        product_get != "" &&
        product_get != undefined &&
        product_get.length != 0
      ) {
        product_list = product_get.split(",");
      }

      if (product_list.includes("TECTALIK_FMS")) {
        this.$router.push("/welcome_page");
      } else {
        this.$router.push("/tasks_detail_mobile");
      }
    },
    backups1() {
      this.$router.push("/team_list");
    },
    backups2() {
      this.$router.push("/quick_links");
    },
    backups3() {
      this.$router.push("/score_list");
    },
    backups4() {
      this.$router.push("/kpi_bots");
    },
    backups5() {
      this.$router.push("/set_strategy");
    },

    UpdateProfile() {
      this.$router.push({ path: "/My_profile" });
    },
    router_pusher(path = "") {
      if (this.$route.path != path) {
        this.$router.push({ path: path });
      }
    },
    profile() {
      this.$router.push("#ProfilePMS");
    },
    openmenu() {
      this.drawer = !this.drawer;
      this.showimage = !this.showimage;
    },
    async login() {
      if (isNaN(this.entity_id) == true || this.entity_id == null) {
        return;
      }
      // Re-mint an entity-bound token for the newly selected entity so the
      // token's signed `ent` claim matches (backend AuthorizeRequest compares
      // request entity_id against this claim).
      // NOTE (20260926052418): This used to be best-effort — on failure it
      // still switched ENTITY_ID while keeping the OLD token, so every later
      // request failed with ERR_AUTH_002 ("session does not match"). Now the
      // switch only happens once the new token is in hand; otherwise the user
      // stays on the current company and is told why.
      if (!(await this.remintTokenForEntity(this.entity_id))) return;

      localStorage.setItem("ENTITY_ID", this.entity_id);
      // Save company ID to localStorage if selected
      if (this.company_id) {
        localStorage.setItem("COMPANY_ID", this.company_id);
      }

      var url_string = "";
      var url_break = window.location.pathname.split("/");
      url_break = url_break[1];
      if (
        url_break == "checklist_Template_page" ||
        url_break == "kpi_additions" ||
        url_break == "templatelibrary" ||
        url_break == "appraisal_add"
      ) {
        url_string = "tapi/";
      }
      axios
        .get(url_string + "get_email_by_entity", {
          params: {
            email: localStorage.getItem("USER_EMAIL"),
            entity_id: this.entity_id,
            user_id: this.user_id,
          },
        })
        .then((response) => {
          const customer = response.data.customer;

          let family_office_flag = response.data.data.family_office_flag;
          let family_tree_flag = response.data.data.family_tree_flag;
          localStorage.setItem("family_office_flag", family_office_flag);
          localStorage.setItem("family_tree_flag", family_tree_flag);

          if (Array.isArray(customer) && customer.length > 0) {
            localStorage.setItem("CUSTOMER_LIST", JSON.stringify(customer[0]));
          } else {
            console.warn("Customer list is empty or not found in response.");
          }
          let employee_dataset = response.data.emp_details;
          let rating_setting = response.data.rating_setting;
          if (rating_setting.length) {
            let self_rating_setting = rating_setting[0].self_rating
              ? "yes"
              : "no";
            localStorage.setItem("Self_Rating_Setting", self_rating_setting);
          } else {
            localStorage.setItem("Self_Rating_Setting", "yes");
          }
          let calc_settings = response.data.calc_settings;
          if (calc_settings.length) {
            let calc = calc_settings[0].show == true ? "yes" : "no";
            localStorage.setItem("kpi_calc", calc);
          } else {
            localStorage.setItem("kpi_calc", "yes");
          }

          if (employee_dataset.length) {
            localStorage.setItem("LOGGED_EMP_ID", employee_dataset[0].id);
            localStorage.setItem("LOGGED_EMP_NO", employee_dataset[0].empno);
          } else {
            localStorage.setItem("LOGGED_EMP_ID", 0);
            localStorage.setItem("LOGGED_EMP_NO", 0);
          }
          let pl = [];
          let product_list = [];
          let product_list_item = response.data.products_by_users;
          if (product_list_item.length != 0) {
            pl = product_list_item.map((a) => a.product_code);
          } else {
            pl = response.data.data.product_list;
          }

          if (pl == "" || pl == null) {
            product_list = [];
          } else {
            product_list = pl;
          }
          // console.log(response, 'response')
          localStorage.setItem("tectalik_product_list", product_list);

          this.set_local_storage(response.data.modules_by_users, response.data.screen_by_users);
          localStorage.setItem("USER_ID", response.data.data.id);
          localStorage.setItem("USER_NAME", response.data.data.name);
          localStorage.setItem("BRANCH_ID", response.data.data.branch_id);
          localStorage.setItem("IS_ADMIN", response.data.is_admin.toString());
          localStorage.setItem("APPRAISAL_PERIOD_MSTR", JSON.stringify(response.data.appraisal_period_mstr));



          if (response.data.data) {
            localStorage.setItem("CHAIRMAN_FLAG", response.data.data.chairman_flag);
            localStorage.setItem("CEO_FLAG", response.data.data.ceo_flag);
            localStorage.setItem("SECRETARY_FLAG", response.data.data.secretary_flag);
            localStorage.setItem("USER_DESIGNATION", response.data.data.designation_name);
            localStorage.setItem("DEPT_ID", response.data.data.department_id || "");
          } else {
            localStorage.setItem("CHAIRMAN_FLAG", false);
            localStorage.setItem("CEO_FLAG", false);
            localStorage.setItem("SECRETARY_FLAG", false);
            localStorage.setItem("USER_DESIGNATION", '');
            localStorage.setItem("DEPT_ID", "");
          }
          sessionStorage.setItem("host_dialog_shown", "true");

          if (this.is_boardpage) {
            const data = response.data.data;
            const isFamilyBook = localStorage.getItem("is_family_book");
            let targetPath = "";

            // Check if user logged in via FamilyBook login
            if (isFamilyBook === "true" || isFamilyBook === true) {

              if (family_office_flag == true) {
                targetPath = "/familybook/Family_Forms";
              } else if (family_tree_flag == true) {
                targetPath = "/familybook/FamilyDashboard";
              } else {
                targetPath = "/familybook/FamilyDashboard";
              }

            } else if (data.chairman_flag === true || data.ceo_flag === true) {
              targetPath = "/BoardDashBoard";
            } else if (data.secretary_flag === true) {
              targetPath = "/SecretaryBoard";
            } else {
              targetPath = "/scorecard_new";
            }

            if (this.$route.path !== targetPath) {
              this.$router.push({ path: targetPath }).then(() => {
                window.location.reload();
              }).catch(() => {});
            } else {
              // Already on the same route — just reload
              window.location.reload();
            }
          } else {
            // Check if user logged in via FamilyBook login (for compliance/tectalik domain)
            const isFamilyBook = localStorage.getItem("is_family_book");
            let targetPath = "";

            if (isFamilyBook === "true" || isFamilyBook === true) {

              if (family_office_flag == true) {
                targetPath = "/familybook/Family_Forms";
              } else if (family_tree_flag == true) {
                targetPath = "/familybook/FamilyDashboard";
              } else {
                targetPath = "/familybook/FamilyDashboard";
              }
            } else if (this.screen_auth('SCN_CEO_DASHBOARD', 'landing')) {
              targetPath = "/CEO_DashBoard";
            } else if (this.screen_auth('SCN_EMPLOYEE_DASHBOARD', 'landing')) {
              targetPath = "/employeedashboard";
            } else {
              targetPath = "/my_work_inbox";
            }

            if (this.$route.path !== targetPath) {
              this.$router.push({ path: targetPath }).then(() => {
                window.location.reload();
              }).catch(() => {});
            } else {
              window.location.reload();
            }
          }
          this.switch_tabs_dialog = false;
          this.switch_dialog = true;
        })
        .catch((error) => {
          console.error("Error in login API call:", error);
          this.overlay_load = false;
        });
    },
    set_local_storage(module_dataset = [], screen_dataset = []) {
      localStorage.setItem("MODULE_RIGHTS_DATASET", JSON.stringify(module_dataset));
      for (let i = 0; i < screen_dataset.length; i++) {
        screen_dataset[i]["hide_all"] = false;
        screen_dataset[i]["module_name"] = false;
        for (let j = 0; j < module_dataset.length; j++) {
          if (screen_dataset[i].modules_rights_id == module_dataset[j].id) {
            screen_dataset[i]["hide_all"] = module_dataset[j].active;
            screen_dataset[i]["module_name"] = module_dataset[j].module_name;
          }
        }
      }
      localStorage.setItem("SCREEN_RIGHT_DATASET", JSON.stringify(screen_dataset));
    },
    logout() {
      // Check if user has SCN_ANALYTICS permission
      let screen_right_dataset = JSON.parse(
        localStorage.getItem("SCREEN_RIGHT_DATASET")
      );

      let hasAnalyticsAccess = false;

      if (
        screen_right_dataset != null &&
        screen_right_dataset != "" &&
        screen_right_dataset != undefined &&
        screen_right_dataset.length != 0
      ) {
        // Filter screen rights for SCN_ANALYTICS
        var filteredScreen = screen_right_dataset.filter(function (item) {
          return item.screen_code === "SCN_ANALYTICS";
        });

        // Check if user has landing permission for SCN_ANALYTICS
        for (var i = 0; i < filteredScreen.length; i++) {
          if (filteredScreen[i].landing) {
            hasAnalyticsAccess = true;
            break;
          }
        }
      }

      // Only call analytics API if user has SCN_ANALYTICS permission
      if (hasAnalyticsAccess) {
        const token_update = {
          token: null,
          email: this.logged_user_Email,
          product_code: "PRMS",
          sub_domain: this.domain,
        };
        axios.post("analytics_token_update", token_update).then(() => {

        }).catch(() => { })
          .finally(() => {
            this.clearStorage();
          });
      } else {
        this.clearStorage();
      }
    },
    prepareEntityData() {
      let data = [];
      try {
        const entityData = localStorage.getItem("entitydata");
        if (entityData) {
          data = JSON.parse(entityData) || [];
        }
      } catch (error) {
        console.error("Error parsing entitydata:", error);
        data = [];
      }
      this.entity__Data = data;
      this.$emit("entity___Data_fn", this.entity__Data);
      this.entity_dataset = [];

      // Build entity dataset with basic info
      if (data && data.length > 0) {
        for (let i = 0; i < data.length; i++) {
          // Check if entity has its own flags, otherwise use host_obj flags
          const entityFlags = {
            starr_flag: data[i].starr_flag !== undefined ? data[i].starr_flag : (this.host_obj?.starr_flag || false),
            board_flag: data[i].board_flag !== undefined ? data[i].board_flag : (this.host_obj?.board_flag || false),
            family_book_flag: data[i].family_book_flag !== undefined ? data[i].family_book_flag : (this.host_obj?.family_book_flag || false)
          };

          console.log(`Entity ${data[i].name} flags:`, entityFlags);

          this.entity_dataset.push({
            id: data[i].id,
            name: data[i].name,
            company_arr: [],
            // Use entity-specific flags from the data, or fall back to host_obj flags
            starr_flag: entityFlags.starr_flag,
            board_flag: entityFlags.board_flag,
            family_book_flag: entityFlags.family_book_flag
          });
        }
      }

      // Map company data to entities
      if (this.company_data_arr && this.company_data_arr.length > 0) {
        for (let j = 0; j < this.entity_dataset.length; j++) {
          // Filter companies belonging to this entity
          const entityCompanies = this.company_data_arr.filter(
            (company) => company.parent_id === this.entity_dataset[j].id
          );
          this.entity_dataset[j].company_arr = entityCompanies || [];
        }
      }
    },
    switch_entity(manualTrigger = false) {
      // This method opens the dialog and prepares data
      this.prepareEntityData();

      // Reset selections when opening dialog (but preserve entity_id if already set)
      const preservedEntityId = this.entity_id;
      this.company_id = null;

      // Load selected_host from localStorage to show it as selected in dialog
      const storedHost = localStorage.getItem("SELECTED_HOST");
      if (storedHost) {
        this.selected_host = storedHost;
      }

      this.has_company_data = false;
      this.company_dataset = [];

      // For single entity scenario, fetch company data
      if (this.isSingleEntityScenario) {
        const storedEntityId = localStorage.getItem("ENTITY_ID");
        if (storedEntityId) {
          this.fetch_company_data(storedEntityId);
          // Also load stored company selection if exists
          const storedCompanyId = localStorage.getItem("COMPANY_ID");
          if (storedCompanyId) {
            this.company_id = parseInt(storedCompanyId);
          }
        }
      }

      // Only set the flag if this was manually triggered by user
      // Don't set it for auto-triggers from checkAndOpenDialog
      if (manualTrigger) {
        sessionStorage.setItem("host_dialog_shown", "true");
      }

      // Open the dialog
      this.switch_tabs_dialog = true;
      this.active_tab = 0;

      // Auto-select logic
      this.$nextTick(() => {
        if (this.entity_dataset.length === 1) {
          // If there's only one entity, auto-select it
          this.selectEntity(this.entity_dataset[0]);
          // Fetch master data for auto-selected entity
          this.fetchMasterDataForEntity(); 
        } else if (preservedEntityId) {
          // If entity was already selected, auto-select host if not already set
          if (!this.selected_host) {
            this.autoSelectHost();
          }
        }
      });
    },
    onLoadDataset() {
      axios
        .get("/get_company_data_and_host_dtls/" + this.user_id)
        .then((response) => {
          this.company_data_arr = response.data.company_data || [];
          this.host_obj = response.data.host_data || { starr_flag: false, board_flag: false, family_book_flag: false };
          // Set user flags from host_obj
          this.user_starr_flag = this.host_obj.starr_flag || false;
          this.user_board_flag = this.host_obj.board_flag || false;
          this.user_family_book_flag = this.host_obj.family_book_flag || false;
          this.user_favourite = this.host_obj.favourite || null;
          // Check company data availability for single entity
          this.checkCompanyData();
          // Just prepare the data, don't open the dialog
          this.prepareEntityData();
          // Check if we should auto-open the dialog
          this.checkAndOpenDialog();
        })
        .catch((error) => {
          console.log(error, "error");
          // Initialize with empty arrays/objects on error
          this.company_data_arr = [];
          this.host_obj = { starr_flag: false, board_flag: false, family_book_flag: false };
          this.user_starr_flag = false;
          this.user_board_flag = false;
          this.user_family_book_flag = false;
          // Just prepare the data, don't open the dialog
          this.prepareEntityData();
          // Check if we should auto-open the dialog
          this.checkAndOpenDialog();
        });
    },
    checkCompanyData() {
      // Check if company_data_arr has data for the current entity
      const entityId = localStorage.getItem("ENTITY_ID");
      if (entityId && this.company_data_arr) {
        const entityCompanies = this.company_data_arr.filter(
          (company) => company.parent_id == entityId
        );
        this.has_company_data = entityCompanies && entityCompanies.length > 0;
      } else {
        this.has_company_data = false;
      }
    },
    checkAndOpenDialog() {
      // GUARD: License acceptance is pending — don't auto-redirect the user
      // away from /license-agreement (the route guard there blocks it anyway,
      // this just avoids the pointless push + uncaught navigation error).
      if (localStorage.getItem("LICENSE_PENDING") === "true") {
        return;
      }

      // GUARD: Prevent infinite loop - check if dialog already shown in this session
      const dialogShownThisSession = sessionStorage.getItem("host_dialog_shown");
      if (dialogShownThisSession === "true") {
        console.log("Dialog already shown this session, skipping auto-open");
        return;
      }

      // Check if we need to open the host selection dialog
      const storedEntityId = localStorage.getItem("ENTITY_ID");
      const storedHost = localStorage.getItem("SELECTED_HOST");
      const entityData = localStorage.getItem("entitydata");

      // Parse entitydata to check entity count
      let parsedEntityData = [];
      try {
        if (entityData) {
          parsedEntityData = JSON.parse(entityData) || [];
        }
      } catch (error) {
        console.error("Error parsing entitydata:", error);
      }

      // Skip for admin domain
      if (this.domain === "admin") {
        return;
      }

      // AUTO-SELECT AND PROCEED: If user has favourite set, skip dialog and proceed directly
      // BUT ONLY if they haven't already made a host selection (storedHost check prevents auto-redirect on new tab)
      // AND ONLY if there's exactly one entity — with multiple entities we can't assume
      // parsedEntityData[0] is the one the user wants, so fall through to the entity picker instead.
      if (this.user_favourite && !storedHost && parsedEntityData.length === 1) {
        const favourite = this.user_favourite.toUpperCase();
        let favouriteHost = null;

        // Check if user's favourite host is available for the first entity
        if (parsedEntityData.length >= 1) {
          const entity = parsedEntityData[0];

          if (favourite === 'FAMILYBOOK' && entity.family_book_flag) {
            console.log("Entity has FAMILYBOOK as user's favourite, auto-selecting and proceeding...");
            favouriteHost = 'familybook';
          } else if (favourite === 'BOARD' && entity.board_flag) {
            console.log("Entity has BOARD as user's favourite, auto-selecting and proceeding...");
            favouriteHost = 'board';
          } else if (favourite === 'STARR' && entity.starr_flag) {
            console.log("Entity has STARR as user's favourite, auto-selecting and proceeding...");
            favouriteHost = 'starr';
          }
        }

        // If user has a valid favourite that entity supports, auto-select and proceed without showing dialog
        if (favouriteHost) {
          // Set entity
          if (parsedEntityData.length >= 1) {
            const entity = parsedEntityData[0];
            this.entity_id = entity.id;
            localStorage.setItem("ENTITY_ID", entity.id);
            localStorage.setItem("entity_name", entity.name);
          }

          // Set the favourite host
          this.selected_host = favouriteHost;
          localStorage.setItem("SELECTED_HOST", favouriteHost);
          localStorage.setItem("selected_host_flag", favouriteHost);

          if (favouriteHost === 'familybook') {
            localStorage.setItem("is_family_book", "true");
            localStorage.setItem("is_boardpage", "false");
          } else if (favouriteHost === 'board') {
            localStorage.setItem("is_family_book", "false");
            localStorage.setItem("is_boardpage", "true");
          } else {
            localStorage.setItem("is_family_book", "false");
            localStorage.setItem("is_boardpage", "false");
          }

          // Mark dialog as shown to prevent re-opening
          sessionStorage.setItem("host_dialog_shown", "true");

          // Proceed with login (navigate to the selected host)
          this.overlay_load = true;
          this.login();
          return;
        }
      }

      // Count available hosts for the user
      const availableHosts = [this.user_starr_flag, this.user_board_flag, this.user_family_book_flag].filter(Boolean);
      const hostCount = availableHosts.length;
      const entityCount = parsedEntityData.length;

      console.log("Auto-selection logic:", { entityCount, hostCount, storedEntityId, storedHost });

      // SCENARIO 3: Single entity + Single host → Auto-select both and navigate
      if (entityCount === 1 && hostCount === 1 && (!storedEntityId || !storedHost)) {
        console.log("SCENARIO 3: Auto-selecting single entity and single host");

        // Set entity
        const entity = parsedEntityData[0];
        this.entity_id = entity.id;
        localStorage.setItem("ENTITY_ID", entity.id);
        localStorage.setItem("entity_name", entity.name);

        // Set host based on entity's flags
        let selectedHost = null;
        if (entity.starr_flag) selectedHost = 'starr';
        else if (entity.board_flag) selectedHost = 'board';
        else if (entity.family_book_flag) selectedHost = 'familybook';

        if (selectedHost) {
          this.selected_host = selectedHost;
          localStorage.setItem("SELECTED_HOST", selectedHost);
          localStorage.setItem("selected_host_flag", selectedHost);
          if (selectedHost === 'familybook') {
            localStorage.setItem("is_family_book", "true");
          } else {
            localStorage.setItem("is_family_book", "false");
          }

          // Mark dialog as shown to prevent re-opening
          sessionStorage.setItem("host_dialog_shown", "true");

          // Navigate directly
          this.overlay_load = true;
          this.login();
        }
        return;
      }

      // SCENARIO 1: Multiple entities + Single host → Ask entity, auto-select host and navigate
      if (entityCount > 1 && hostCount === 1 && !storedEntityId) {
        console.log("SCENARIO 1: Multiple entities, single host - showing entity selection");
        // Show dialog for entity selection, host will be auto-selected in proceedWithSelection
        // Don't set flag yet - set it after user makes selection
        this.switch_entity();
        return;
      }

      // SCENARIO 2: Single entity + Multiple hosts → Ask to select host
      if (entityCount === 1 && hostCount > 1 && !storedHost) {
        console.log("SCENARIO 2: Single entity, multiple hosts - showing host selection");

        // Auto-set entity
        const entity = parsedEntityData[0];
        this.entity_id = entity.id;
        localStorage.setItem("ENTITY_ID", entity.id);
        localStorage.setItem("entity_name", entity.name);

        // Show dialog for host selection
        // Don't set flag yet - set it after user makes selection
        this.switch_entity();
        return;
      }

      // SCENARIO 4: Multiple entities + Multiple hosts → Ask to select both
      if (entityCount > 1 && hostCount > 1 && !storedEntityId) {
        // console.log("SCENARIO 4: Multiple entities and hosts - showing selection dialog");
        // Don't set flag yet - set it after user makes selection
        this.switch_entity();
        return;
      }

      // SCENARIO 5: Single entity + No hosts → Error/warning
      if (entityCount === 1 && hostCount === 0) {
        console.error("SCENARIO 5: User has no host access");
        // this.$toast.error('You do not have access to any host. Please contact your administrator.');
        // this.switch_entity();
        return;
      }

      // If we reach here, entity and host are already selected (user came back to page)
      console.log("Entity and host already selected, no dialog needed");
    },
    app_version() {
      this.currentUrl = window.location.href;
      const urlParts = this.currentUrl.split("/");
      let rout = urlParts[3];

      const exemptRoutes = [
        "health_check_answer", "finance_health_questions", "health_check_dashboard",
        "health_check_dashboard_view", "health_check_home_screen",
        "completion_screen_health_check", "payment-required", "login",
      ];

      // Only alert if resultat exists AND is a different version (not on first login)
      if (this.resultat && this.applicationVersion != this.resultat) {
        if (!exemptRoutes.includes(rout)) {
          alert("New version is out! Please logout and re-login to continue");
        }
      }
      // Always sync resultat silently
      localStorage.setItem("resultat", this.applicationVersion);
      this.resultat = this.applicationVersion;
    },
    autoSelectHost() {
      // Only auto-select host if it was previously stored (user already made a selection before)
      // Do NOT auto-select on first login - let user manually choose
      const storedHost = localStorage.getItem("SELECTED_HOST");

      if (!storedHost) {
        // No previous selection - don't auto-select, let user choose
        return;
      }

      // If user previously selected a host, restore that selection
      // Validate they still have access to that host
      const hostname = window.location.hostname;
      const currentPath = this.$route ? this.$route.path : '';

      // Check if familybook is in the router path or stored host
      if (storedHost === 'familybook' && (currentPath.includes('familybook') || hostname.includes('familybook'))) {
        if (this.entity_dataset.find(e => e.id === this.entity_id && e.user_family_book_flag)) {
          this.selected_host = 'familybook';
        }
      }
      // Check if page is hosted in compliance (Starr)
      else if (storedHost === 'starr' && (hostname.includes('compliance') || hostname.includes('tectalik'))) {
        if (this.entity_dataset.find(e => e.id === this.entity_id && e.user_starr_flag)) {
          this.selected_host = 'starr';
        }
      }
      // Check if page is myboardpage (Board)
      else if (storedHost === 'board' && hostname.includes('myboardpage')) {
        if (this.entity_dataset.find(e => e.id === this.entity_id && e.user_board_flag)) {
          this.selected_host = 'board';
        }
      }
    },
    // Methods Ends
  },
};
</script>
<style scoped>

* {
  font-family: 'Poppins', sans-serif !important;
}

.switch-company-card {
  border-radius: 4px;
  padding: 0px 24px 56px 24px;
  /* extra bottom padding for button */
  position: relative;
  min-height: 400px;
}

.proceed-actions-fixed {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 16px 24px;
  background: #fff;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.04);
  display: flex;
  justify-content: center;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  z-index: 10;
}

.company-radio-group {
  width: 100%;
}

.company-label {
  font-size: 14px;
  font-weight: 500;
  color: #181C32;
  margin-left: 8px;
}

.proceed-btn {
  width: 100px;
  color: #fff !important;
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize !important;
}

.cancel-btn {
  width: 100px;
  font-size: 14px;
  font-weight: 500;
  text-transform: capitalize !important;
}

.v-sheet {
  transition: background 0.2s, box-shadow 0.2s;
}

.selection-card {
  transition: all 0.3s ease;
  overflow: hidden;
}

.selection-item {
  transition: all 0.2s ease;
}

.selection-item:hover {
  opacity: 0.9;
  transform: translateX(4px);
}

.section-title {
  font-size: 12px;
  font-weight: 600;
  color: #7E8299;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-left: 4px;
}

.selection-label {
  font-size: 14px;
  font-weight: 500;
  color: #181C32;
}

.entity-label {
  color: #3F51B5;
}

.company-label {
  color: #4CAF50;
}

.host-label {
  color: #FF9800;
}

/* Star icon styling */
.v-icon.mdi-star,
.v-icon.mdi-star-outline {
  transition: all 0.2s ease;
}

.v-icon.mdi-star {
  filter: drop-shadow(0 2px 4px rgba(255, 152, 0, 0.3));
}

.selection-item:hover .v-icon {
  transform: scale(1.1);
}

/* Horizontal Selection Layout Styles */
.horizontal-layout-container {
  margin-top: 25px;
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
}

.selection-column {
  min-height: 150px;
  padding: 0 16px;
}

.selection-column:first-child {
  padding-left: 0;
}

.selection-column:last-child {
  padding-right: 0;
}

/* Vertical Divider */
.vertical-divider {
  width: 1px;
  background: linear-gradient(to bottom, transparent, #E4E6EF 10%, #E4E6EF 90%, transparent);
  margin: 0 8px;
  align-self: stretch;
  min-height: 100px;
}

/* Section specific styles */
.entity-section,
.company-section,
.host-section {
  flex: 1;
}

.selection-list {
  max-height: 280px;
  overflow-y: auto;
  padding-right: 8px;
}

.selection-list::-webkit-scrollbar {
  width: 8px;
}

.selection-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.selection-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.selection-list::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .horizontal-layout-container {
    flex-direction: column;
    flex-wrap: wrap;
  }

  .selection-column {
    padding: 0;
    border-bottom: 1px solid #E4E6EF;
    padding-bottom: 16px;
    margin-bottom: 16px;
  }

  .selection-column:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }

  .vertical-divider {
    display: none !important;
  }
}
</style>